import React, { useState }  from 'react'
import TranslationCont from "../../General/TranslationCont"
import ButtonFocusAccess from "../Core/ButtonFocusAccess"
import { useTabs } from "./useTabs"

const TabsManualActivationTablist = ({
    labelledby,
    tabConfig,
    expandedId,
    toggleExpanded
})  => {
    const [index, focusIndex, onKeydown, handleClick] = useTabs(tabConfig.length)

    return (
        <div className="access-tablist" role='tablist' aria-labelledby={labelledby}>
            {tabConfig.map((t, i) => {
                const isExpanded = expandedId === t.controls

                const addProps = {
                    ...(i !== index) && {tabIndex: -1},
                }

                return <ButtonFocusAccess
                    id={t.id}
                    key={t.id}
                    role='tab'
                    className={"access-tab" + (isExpanded ? ' is-expanded' : '')}
                    aria-controls={t.controls}
                    aria-selected={isExpanded}
                    buttonTransId={t.transId}
                    buttonText={t.text}
                    hasFocus={focusIndex === i}
                    onClick={() => {
                        handleClick(i)
                        toggleExpanded(t.controls)
                    }}
                    onKeyDown={onKeydown}
                    {...addProps}
                />
            })}
        </div>
    )
}

export default TabsManualActivationTablist